import {useEffect, useState} from "react";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import RichiestaInviataDialog
    from "../../../../../../shared/components/dialogs/richiesta-inviata-dialog/RichiestaInviataDialog";
import Typography from "@material-ui/core/Typography";
import GrayHeaderCard from "../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import Grid from "@material-ui/core/Grid";
import DefaultInput from "../../../../../ui/inputs/default-input/DefaultInput";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import RichiediDelleFattureNotification
    from "../../../../../ui/notifications/richiedi-delle-fatture-notification/RichiediDelleFattureNotification";
import * as actions from "../../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import ButtonWithProgress from "../../../../../ui/buttons/button-with-progress/ButtonWithProgress";

const useStyles = makeStyles({
    gridContainer: {
        padding: "1em",
        '& .MuiTypography-root': {
            paddingTop: "0.5em"
        }
    }
})

const RichiediModificaDelleFattureDialog = ({...props}) => {
    const classes = useStyles();
    const [openRichiestaInviata, setOpenRichiestaInviata] = useState(false);
    const [inputFieldValues, setInputFieldValues] = useState({
        azienda: "",
        ufficio: "",
        indirizzo: "",
        cap: "",
        citta: "",
        provincia: "",
        noteAggiuntive: ""
    })
    const userClaims = useSelector(state => state.authReducer.userClaims);
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany);
    const customerAddress = useSelector(state => state.serviceRequestReducer.customerAddress);
    const loadingAddressForCustomer = useSelector(state => state.serviceRequestReducer.loadingAddressForCustomer);
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.getAddressForCustomerId(selectedCompany.integrationId));
    }, [dispatch, selectedCompany.integrationId]);

    const handleAnnulaClick = () => {
        props.handleDialogClose();
        dispatch(actions.clearCustomerAddress());
    }

    const createNote = () => {
        let separator = " - ";
        return inputFieldValues.azienda + separator + inputFieldValues.ufficio + separator + inputFieldValues.indirizzo + separator
            + inputFieldValues.cap + separator + inputFieldValues.citta + separator
            + inputFieldValues.provincia + separator + inputFieldValues.noteAggiuntive;
    }

    const handleInviaClick = () => {
        const note = createNote();
        dispatch(actions.submitReportInSegnalazione(
            selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId,
            props.screenCode,
            userClaims.uid,
            "",
            "",
            "",
            inputFieldValues.noteAggiuntive,
            "",
            [],
            note
        ));
        setOpenRichiestaInviata(true);
        dispatch(actions.clearCustomerAddress())
    }

    const handleDialogClose = () => {
        props.handleDialogClose();
        dispatch(actions.clearCustomerAddress())
    }

    const handleDialogCloseButton = () => {
        props.handleDialogCloseButton();
        dispatch(actions.clearCustomerAddress())
    }

    const handleRichiestaInviataButton = () => {
        setOpenRichiestaInviata(false);
        props.handleDialogClose();
    }

    const handleRichiestaCloseButton = () => {
        setOpenRichiestaInviata(false);
        props.handleDialogClose();
    }

    const disableButton = !(inputFieldValues.azienda !== "" &&
        inputFieldValues.ufficio !== "" &&
        inputFieldValues.indirizzo !== "" &&
        inputFieldValues.cap !== "" &&
        inputFieldValues.citta !== "" &&
        inputFieldValues.provincia !== "");

    const inputFields = [
        {
            name: "azienda",
            label: "Azienda",
            inputLabel: "Inserisci nome e cognome",
            multiline: false,
            value: inputFieldValues.azienda,
            handleChange: (event) => {
                handleInputChange(event)
            }
        },
        {
            name: "ufficio",
            label: "Ufficio, referente",
            inputLabel: "Inserisci ufficio, interno o referente",
            multiline: false,
            value: inputFieldValues.ufficio,
            handleChange: (event) => {
                handleInputChange(event)
            }
        },
        {
            name: "indirizzo",
            label: "Indirizzo",
            inputLabel: "Inserisci Via e numero civico",
            multiline: false,
            value: inputFieldValues.indirizzo,
            handleChange: (event) => {
                handleInputChange(event)
            }
        },
        {
            name: "cap",
            label: "CAP",
            inputLabel: "Inserisci CAP",
            multiline: false,
            value: inputFieldValues.cap,
            handleChange: (event) => {
                handleInputChange(event)
            }
        },
        {
            name: "citta",
            label: "Città",
            inputLabel: "Inserisci comune",
            multiline: false,
            value: inputFieldValues.citta,
            handleChange: (event) => {
                handleInputChange(event)
            }
        },
        {
            name: "provincia",
            label: "Provincia",
            inputLabel: "Inserisci provincia",
            multiline: false,
            value: inputFieldValues.provincia,
            handleChange: (event) => {
                handleInputChange(event)
            }
        },
        {
            name: "noteAggiuntive",
            label: "Note aggiuntive",
            inputLabel: "Scrivi qui ulteriori dettagli",
            multiline: true,
            value: inputFieldValues.noteAggiuntive,
            handleChange: (event) => {
                handleInputChange(event)
            }
        }
    ];

    const handleInputChange = (event) => {
        setInputFieldValues({...inputFieldValues, [event.target.name]: event.target.value})
    }

    const createRow = (index, label, inputLabel, multiline, name, value, handleChange) => {
        return (
            <Grid key={index} container className={classes.gridContainer}>
                <Grid item xs={12} sm={3} md={3} container alignItems="center">
                    <Typography variant={"subtitle1"}>{label}</Typography>
                </Grid>
                <Grid item xs={12} sm={9} md={9}>
                    {
                        multiline ?
                            <FormControl fullWidth>
                                <TextField
                                    rows={4}
                                    label={inputLabel}
                                    name={name}
                                    multiline
                                    variant="outlined"
                                    onChange={handleChange}
                                    value={value}
                                />
                            </FormControl>
                            :
                            <DefaultInput
                                type="text"
                                name={name}
                                label={inputLabel}
                                onChange={handleChange}
                                value={value}
                            />
                    }
                </Grid>
            </Grid>
        );
    }

    const dialogContent = (
        <>
            <RichiediDelleFattureNotification text={customerAddress}
                                              title={"Indirizzo corrente"}/>
            <GrayHeaderCard
                className="mb-24 card-width-richiedi-dialog"
                height="thin"
                title={<Typography variant="subtitle1">Indica il nuovo indirizzo</Typography>}
            >
                <>
                    {inputFields.map((inputField, index) => (
                        createRow(index, inputField.label, inputField.inputLabel, inputField.multiline, inputField.name, inputField.value, inputField.handleChange)
                    ))}
                </>
            </GrayHeaderCard>
            {openRichiestaInviata && !loadingReportProblem && !errorReportProblem ? (
                <RichiestaInviataDialog
                    open={openRichiestaInviata}
                    handleDialogClose={handleRichiestaInviataButton}
                    handleRichiestaCloseButton={handleRichiestaCloseButton}
                />
            ) : null}
        </>
    );

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button onClick={handleAnnulaClick}
                    color="primary"
                    variant="outlined">
                <div className="align-center-x px-16">Annulla</div>
            </Button>

            <ButtonWithProgress handleClick={handleInviaClick}
                                text={"Invia"}
                                loading={loadingReportProblem}
                                disabled={disableButton}/>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={handleDialogClose}
            handleDialogCloseButton={handleDialogCloseButton}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
            loading={loadingAddressForCustomer}
        >
            <Typography variant={"h5"}>
                Richiedi modifica dell’indrizzo di spedizione delle fatture
            </Typography>
        </GenericDialog>
    )


}


export default RichiediModificaDelleFattureDialog;
